module.exports = __webpack_public_path__ + "static/media/brownbag.28e55455.jpg";